/**
 * Returns a number string with breaking commas from a number with no commas
 * @param inputString
 * @returns {string}
 */

function addCommasToNumber(inputString = '') {
  return parseInt(inputString.replace(/,/g, ''), 10).toLocaleString();
}

export default addCommasToNumber;
